// What the page you're on tells Courage Chat: what's open (so questions and proposed changes are about it), starting
// suggestions, and what to do around a confirmed change (save the editor first, reload after). The side panel reads it.
import { useSyncExternalStore } from "react";

export type PageChat = {
  context: string; // e.g. "process:<id>", sent with each question
  placeholder?: string;
  prompts?: string[];
  beforeConfirm?: () => Promise<void>;
  onChanged?: () => void;
};

let current: PageChat | null = null;
const subs = new Set<() => void>();

export function setPageChat(p: PageChat | null) { current = p; subs.forEach((f) => f()); }
export function usePageChat(): PageChat | null {
  return useSyncExternalStore((f) => { subs.add(f); return () => { subs.delete(f); }; }, () => current);
}
/** Open the Courage Chat side panel. */
export const openChat = () => window.dispatchEvent(new Event("courage:open-chat"));
